/**
 * UG localization-configuration parsing.
 *
 * The adapter stamps each item/page with its `localizationConfiguration` (the
 * set of country codes it is enabled in). The actual per-country filtering of
 * adapted content happens once, downstream in `lib/cms/bffClient.ts`, which
 * applies a brand-agnostic filter to the unified content for gallet + ug alike.
 */

/**
 * Normalize the Contentful `localizationConfiguration` JSON field to a
 * lowercase string array of country codes. Contentful stores this as a JSON
 * value that can be an array of strings, null, or undefined.
 */
export function adaptLocalizationConfiguration(raw: unknown): string[] | null {
  if (!Array.isArray(raw)) return null;
  const codes = raw.filter((v): v is string => typeof v === 'string');
  if (codes.length === 0) return null;
  return codes.map((c) => c.toLowerCase());
}
